import { useCallback } from 'react';
import { useLatestLoad } from '../../hooks/useLatestLoad';
import { fetchStockMovements } from '../adminApi';
import { dayShort } from '../../core/format/dates';
import { locationLabel, reasonLabel } from '../../core/rules/stockMovements';
import type { RequestOptions } from '../../core/types/backend';
import type { WriteOffCause } from '../../core/types/stock';
const causeLabel: Record<WriteOffCause, string> = {
  kapot: 'kapot',
  'over-datum': 'over datum',
  tester: 'tester',
  cadeau: 'cadeau',
  marketing: 'marketing',
  anders: 'anders'
};

/** Het log van één artikel, nieuwste bovenaan. Na een actie geeft de ouder een nieuwe `key`, dan laadt hij opnieuw. */
export function StockHistory({
  itemId
}: {
  itemId: string;
}) {
  const load = useCallback((opts: RequestOptions) => fetchStockMovements(itemId, opts), [itemId]);
  const {
    data,
    status,
    reload
  } = useLatestLoad(load);
  if (status === 'error' && !data) {
    return <p className="text-[13px] text-clay" data-id="element-4782" data-mp="ovqv3g71zb2r">
        De historie laden lukte niet.{' '}
        <button type="button" onClick={reload} className="underline underline-offset-2" data-id="element-4783" data-mp="3dox4nhoo0s4z">
          Opnieuw
        </button>
      </p>;
  }
  if (!data) return <p className="text-[13px] text-muted" data-id="element-4784" data-mp="3mpn18nlr2mjr">Historie laden…</p>;
  if (data.length === 0) return <p className="text-[13px] text-muted" data-id="element-4785" data-mp="3rozjsw5l97gj">Nog geen mutaties.</p>;
  return <ol className="divide-y divide-line text-[13px]" aria-label="Historie" data-id="element-4786" data-mp="3rmvk6qeq2um2">
      {data.map(m => <li key={m.id} className="flex flex-wrap items-baseline gap-x-3 gap-y-0.5 py-2" data-id="element-4787" data-mp="2tzmrobgb0lak">
          <span className="w-24 shrink-0 tabular-nums text-muted" data-id="element-4788" data-mp="2yyhh3w8s183n">
            {dayShort(m.at.slice(0, 10))} {m.at.slice(11, 16)}
          </span>
          <span className="min-w-0 flex-1 text-ink" data-id="element-4789" data-mp="38qn8b3r7flhs">
            {reasonLabel[m.reason]}
            {m.writeOffCause && ` (${causeLabel[m.writeOffCause]})`}
            <span className="text-muted" data-id="element-4790" data-mp="2b95bf6cnri63"> · {locationLabel[m.location]}</span>
            {m.ref && <span className="text-muted" data-id="element-4791" data-mp="2g7zsa2r2ewnk"> · {m.ref}</span>}
            {m.note && <span className="block text-[12px] text-muted" data-id="element-4792" data-mp="288261antgel4">{m.note}</span>}
          </span>
          <span className={`tabular-nums ${m.qty < 0 ? 'text-clay' : 'text-ink'}`} data-id="element-4793" data-mp="246qc4sxwt774">
            {m.qty > 0 ? '+' : ''}
            {m.qty}
          </span>
          <span className="w-14 text-right text-[12px] text-muted" data-id="element-4794" data-mp="2d03f6npotp6x">{m.by}</span>
        </li>)}
    </ol>;
}